import { initializeApp, type FirebaseOptions } from "firebase/app";
import { getMessaging, isSupported, type Messaging } from "firebase/messaging";
import useCirclemsConfig from "~/composables/config/useCirclemsConfig";

// このファイルは client-app-jp/eslint.config.mjs 対象外のため 具体的な処理が必要であれば別ファイルに記述すること
export default defineNuxtPlugin(async () => {
    const config = useCirclemsConfig().get();
    const firebaseConfig = JSON.parse(String(config.circlemsConfig.FIREBASE_CONFIG)) as FirebaseOptions; // TODO(as-cast): 強制型キャスト。安全な型付けへ置換を検討
    // Service Worker 非対応環境(LINE等のアプリ内ブラウザなど)では getMessaging が
    // navigator.serviceWorker 参照で例外を投げ、Nuxt 全体が 500 になるためガードする
    let messaging: Messaging | null = null;
    if (await isSupported()) {
        const firebaseApp = initializeApp(firebaseConfig);
        messaging = getMessaging(firebaseApp);
    }
    else {
        await navigateTo("/unsupported", { replace: true });
    }
    return { provide: { messaging } };
});
